import { HomeMinusIcon } from './HomeMinusIcon';

/**
 * author: Peter Noble
 * id 825AF439-6839-48DA-A6D4-B62BB2710103
 * name home-minus
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-minus.svg
 * tags
 * - Home Automation 
 */
export const HouseMinusIcon = HomeMinusIcon;
export default HouseMinusIcon